(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norlan-hero"]) return;
  try {
    
(function(){
var reduceMotionParam = /[?&]nr_motion=0(&|$)/.test(window.location.search);
var reduceMotion = reduceMotionParam || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
var hero = document.getElementById('nrHero');
var loader = document.getElementById('nrHeroLoader');
var scene = document.getElementById('nrHeroScene');
var photoWrap = document.getElementById('nrPhotoWrap');
var fogCanvas = document.getElementById('nrFogCanvas');
var content = document.getElementById('nrHeroContent');
var title = document.getElementById('nrHeroTitle');
var scrollCue = document.getElementById('nrHeroScrollCue');
if(!hero) return;

function revealHero(){
  hero.querySelectorAll('.nr-hero-reveal').forEach(function(el){ el.classList.add('nr-hero-in'); });
  if(title){
    title.classList.add('nr-title-in');
    if(!reduceMotion){ setTimeout(function(){ title.classList.add('nr-title-sheen'); }, 250); }
  }
}
function showScene(){ if(scene) scene.classList.add('nr-scene-in'); }
function hideLoader(){ if(loader){ loader.classList.add('nr-hidden'); } showScene(); revealHero(); }
var minTimePassed = false, fontsDone = false;
setTimeout(function(){ minTimePassed = true; if(fontsDone) hideLoader(); }, reduceMotion ? 0 : 340);
function onFontsReady(){ fontsDone = true; if(minTimePassed) hideLoader(); }
if(document.fonts && document.fonts.ready){ document.fonts.ready.then(onFontsReady).catch(onFontsReady); }
else { onFontsReady(); }
setTimeout(hideLoader, 1800);

function rand(min,max){ return Math.random()*(max-min)+min; }

var ctx = fogCanvas ? fogCanvas.getContext('2d') : null;
var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
var w = 0, h = 0, fogBlobs = [], mistParticles = [];

function resize(){
  var rect = hero.getBoundingClientRect();
  w = rect.width; h = rect.height;
  if(fogCanvas){
    fogCanvas.width = Math.round(w*dpr);
    fogCanvas.height = Math.round(h*dpr);
    fogCanvas.style.width = w+'px';
    fogCanvas.style.height = h+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }
  buildScene();
}

function buildScene(){
  var isSmall = w < 750;
  var fogCount = isSmall ? 4 : 7;
  fogBlobs = [];
  for(var i=0;i<fogCount;i++){
    fogBlobs.push({
      x: rand(0,w), y: rand(h*0.35,h*1.05),
      radius: rand(Math.max(w,h)*0.2, Math.max(w,h)*0.4),
      driftSpeed: rand(0.02,0.06), phase: rand(0,Math.PI*2),
      opacity: rand(0.09,0.2),
      tone: Math.random() > 0.6 ? 'gold' : 'bone'
    });
  }
  var mistCount = isSmall ? 22 : 44;
  mistParticles = [];
  for(var j=0;j<mistCount;j++){
    mistParticles.push({
      x: rand(0,w), y: rand(0,h), r: rand(0.6,2.1),
      speedY: rand(5,14), swayAmp: rand(10,30), swaySpeed: rand(0.15,0.4),
      phase: rand(0,Math.PI*2), opacity: rand(0.12,0.42)
    });
  }
}

function draw(t){
  if(!ctx) return;
  var time = t/1000;
  ctx.clearRect(0,0,w,h);
  fogBlobs.forEach(function(f){
    var dx = Math.cos(time*f.driftSpeed+f.phase)*50;
    var dy = Math.sin(time*f.driftSpeed*0.6+f.phase)*28;
    var g = ctx.createRadialGradient(f.x+dx,f.y+dy,0,f.x+dx,f.y+dy,f.radius);
    var color = f.tone === 'gold' ? '201,162,39' : '230,225,210';
    g.addColorStop(0,'rgba('+color+','+f.opacity+')');
    g.addColorStop(1,'rgba('+color+',0)');
    ctx.fillStyle = g;
    ctx.beginPath(); ctx.arc(f.x+dx,f.y+dy,f.radius,0,Math.PI*2); ctx.fill();
  });
  mistParticles.forEach(function(p){
    p.y -= p.speedY/60;
    if(p.y < -10){ p.y = h+10; p.x = rand(0,w); }
    var sway = Math.sin(time*p.swaySpeed+p.phase)*p.swayAmp;
    ctx.beginPath();
    ctx.fillStyle = 'rgba(245,241,230,'+p.opacity+')';
    ctx.arc(p.x+sway,p.y,p.r,0,Math.PI*2); ctx.fill();
  });
  raf = requestAnimationFrame(draw);
}

var raf = null;
var visible = true;
document.addEventListener('visibilitychange', function(){ visible = document.visibilityState === 'visible'; });

resize();
if(!reduceMotion){
  raf = requestAnimationFrame(draw);
} else {
  draw(0);
  if(raf) cancelAnimationFrame(raf);
}

var resizeTimer;
window.addEventListener('resize', function(){ clearTimeout(resizeTimer); resizeTimer = setTimeout(resize, 150); });

if(!reduceMotion){
  var isDesktop = window.matchMedia('(min-width: 900px) and (hover: hover)').matches;
  if(isDesktop){
    hero.addEventListener('mousemove', function(e){
      var rect = hero.getBoundingClientRect();
      var px = (e.clientX-rect.left)/rect.width - 0.5;
      var py = (e.clientY-rect.top)/rect.height - 0.5;
      if(photoWrap) photoWrap.style.transform = 'translate(' + (px*-8) + 'px,' + (py*-6) + 'px)';
      if(fogCanvas) fogCanvas.style.transform = 'translate(' + (px*-16) + 'px,' + (py*-10) + 'px)';
    });
  }
}

var ticking = false;
function onScroll(){
  var heroH = hero.getBoundingClientRect().height || window.innerHeight;
  var progress = Math.min(Math.max(window.scrollY / (heroH*0.7), 0), 1);
  if(scene){
    scene.style.opacity = String(1 - progress);
    if(!reduceMotion) scene.style.filter = 'blur(' + (progress*9) + 'px)';
  }
  if(!reduceMotion && photoWrap) photoWrap.style.marginTop = (progress*-24) + 'px';
  if(!reduceMotion && content) content.style.transform = 'translateY(calc(-50% + ' + (progress*30) + 'px))';
  if(scrollCue) scrollCue.style.opacity = String(Math.max(1 - progress*5,0));
}
window.addEventListener('scroll', function(){
  if(!ticking){ window.requestAnimationFrame(function(){ onScroll(); ticking=false; }); ticking=true; }
}, {passive:true});

(function(){
  var forceMotionPreview = /[?&]motion-preview=true(&|$)/.test(window.location.search);
  var reduceMotionLocal = /[?&]nr_motion=0(&|$)/.test(window.location.search) || (!forceMotionPreview && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var wrap = document.getElementById('nrPressureWrap');
  var titleEl = document.getElementById('nrHeroTitle');
  if(!wrap || !titleEl) return;
  var desktopQuery = window.matchMedia('(min-width: 750px)');
  if(!desktopQuery.matches) return;
  var text = titleEl.textContent.trim();
  var chars = text.split('');
  titleEl.innerHTML = '';
  var spans = chars.map(function(ch){
    var span = document.createElement('span');
    span.textContent = ch === ' ' ? ' ' : ch;
    span.setAttribute('aria-hidden', 'true');
    titleEl.appendChild(span);
    return span;
  });

  var mouse = {x:0,y:0}, cursor = {x:0,y:0};
  var raf = null;
  var minFontSize = 48, maxFontSize = 210;

  function setInitial(){
    var r = wrap.getBoundingClientRect();
    mouse.x = r.left + r.width/2;
    mouse.y = r.top + r.height/2;
    cursor.x = mouse.x; cursor.y = mouse.y;
  }

  function setSize(){
    var cw = wrap.getBoundingClientRect().width;
    var fs = cw / (chars.length/2);
    fs = Math.max(minFontSize, Math.min(maxFontSize, fs));
    titleEl.style.fontSize = fs + 'px';
  }

  function dist(a,b){ var dx=b.x-a.x, dy=b.y-a.y; return Math.sqrt(dx*dx+dy*dy); }
  function getAttr(distance, maxDist, minVal, maxVal){
    var t = Math.min(Math.max(distance / maxDist, 0), 1);
    return maxVal - t * (maxVal - minVal);
  }

  function animate(){
    mouse.x += (cursor.x - mouse.x)/15;
    mouse.y += (cursor.y - mouse.y)/15;
    var titleRect = titleEl.getBoundingClientRect();
    var maxDist = Math.max(titleRect.width/2, 1);
    spans.forEach(function(span){
      var r = span.getBoundingClientRect();
      var c = {x:r.x+r.width/2, y:r.y+r.height/2};
      var d = dist(mouse, c);
      var wght = Math.floor(getAttr(d, maxDist, 280, 900));
      var wdth = Math.floor(getAttr(d, maxDist, 60, 151));
      var ital = getAttr(d, maxDist, 0, 1).toFixed(2);
      var settings = "'wght' " + wght + ", 'wdth' " + wdth + ", 'ital' " + ital;
      if(span.style.fontVariationSettings !== settings){ span.style.fontVariationSettings = settings; }
    });
    raf = requestAnimationFrame(animate);
  }

  function activate(){
    titleEl.classList.add('nr-pressure-active');
    setSize();
    if(!reduceMotionLocal){
      setInitial();
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('touchmove', onTouchMove, {passive:true});
      if(!raf) raf = requestAnimationFrame(animate);
    }
  }
  function deactivate(){
    titleEl.classList.remove('nr-pressure-active');
    titleEl.style.fontSize = '';
    spans.forEach(function(span){ span.style.fontVariationSettings = ''; });
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('touchmove', onTouchMove);
    if(raf){ cancelAnimationFrame(raf); raf = null; }
  }
  function onMouseMove(e){ cursor.x = e.clientX; cursor.y = e.clientY; }
  function onTouchMove(e){ var t = e.touches[0]; if(!t) return; cursor.x = t.clientX; cursor.y = t.clientY; }

  function sync(){ if(desktopQuery.matches){ activate(); } else { deactivate(); } }
  sync();
  desktopQuery.addEventListener ? desktopQuery.addEventListener('change', sync) : desktopQuery.addListener(sync);

  var resizeTimer2;
  window.addEventListener('resize', function(){
    clearTimeout(resizeTimer2);
    resizeTimer2 = setTimeout(function(){ if(desktopQuery.matches) setSize(); }, 120);
  });
})();

(function(){
  var forceMotionPreview = /[?&]motion-preview=true(&|$)/.test(window.location.search);
  var reduceMotionLocal = /[?&]nr_motion=0(&|$)/.test(window.location.search) || (!forceMotionPreview && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var wrap = document.getElementById('nrCoordsFuzzy');
  if(!wrap) return;
  var canvases = Array.from(wrap.querySelectorAll('canvas[data-fuzzy-line]'));
  if(!canvases.length) return;

  var refColor = getComputedStyle(document.documentElement).getPropertyValue('--nr-muted').trim() || 'rgba(245,241,230,.72)';
  var refFontFamily = getComputedStyle(wrap).fontFamily || 'sans-serif';

  var baseIntensity = 0.05;
  var hoverIntensity = 0.13;
  var fontSize = 11;
  var fontWeight = 300;
  var letterSpacingEm = 0.08;

  function makeFuzzyLine(canvas, text){
    var fuzzRange = 5;
    var letterSpacingPx = letterSpacingEm * fontSize;
    var margin = fuzzRange + 6;

    var init = function(){
      var ctx = canvas.getContext('2d');
      var fontString = fontWeight + ' ' + fontSize + 'px ' + refFontFamily;

      var offscreen = document.createElement('canvas');
      var offCtx = offscreen.getContext('2d');
      offCtx.font = fontString;
      offCtx.textBaseline = 'alphabetic';

      var chars = text.split('');
      var totalWidth = 0;
      chars.forEach(function(ch, i){
        totalWidth += offCtx.measureText(ch).width;
        if(i < chars.length - 1) totalWidth += letterSpacingPx;
      });

      var metrics = offCtx.measureText(text);
      var actualAscent = metrics.actualBoundingBoxAscent || fontSize;
      var actualDescent = metrics.actualBoundingBoxDescent || fontSize * 0.25;
      var textBoundingWidth = Math.ceil(totalWidth);
      var tightHeight = Math.ceil(actualAscent + actualDescent);

      var extraBuffer = 4;
      var offscreenWidth = textBoundingWidth + extraBuffer;
      offscreen.width = offscreenWidth;
      offscreen.height = tightHeight;

      offCtx.font = fontString;
      offCtx.textBaseline = 'alphabetic';
      offCtx.fillStyle = refColor;
      var xPos = extraBuffer / 2;
      chars.forEach(function(ch){
        offCtx.fillText(ch, xPos, actualAscent);
        xPos += offCtx.measureText(ch).width + letterSpacingPx;
      });

      canvas.width = offscreenWidth + margin * 2;
      canvas.height = tightHeight;
      ctx.translate(margin, 0);

      var interactiveLeft = margin;
      var interactiveRight = margin + offscreenWidth;
      var interactiveTop = 0;
      var interactiveBottom = tightHeight;

      var isHovering = false;
      var raf = null;

      function drawStatic(){
        ctx.clearRect(-margin, -margin, canvas.width + margin, tightHeight + margin * 2);
        ctx.drawImage(offscreen, 0, 0);
      }

      function loop(){
        ctx.clearRect(-margin, -margin, canvas.width + margin, tightHeight + margin * 2);
        var intensity = isHovering ? hoverIntensity : baseIntensity;
        for(var j = 0; j < tightHeight; j++){
          var dx = Math.floor(intensity * (Math.random() - 0.5) * fuzzRange);
          ctx.drawImage(offscreen, 0, j, offscreenWidth, 1, dx, j, offscreenWidth, 1);
        }
        raf = requestAnimationFrame(loop);
      }

      if(reduceMotionLocal){
        drawStatic();
      } else {
        raf = requestAnimationFrame(loop);
      }

      function isInsideTextArea(x, y){
        return x >= interactiveLeft && x <= interactiveRight && y >= interactiveTop && y <= interactiveBottom;
      }
      function handleMouseMove(e){
        var rect = canvas.getBoundingClientRect();
        isHovering = isInsideTextArea(e.clientX - rect.left, e.clientY - rect.top);
      }
      function handleMouseLeave(){ isHovering = false; }
      function handleTouchMove(e){
        var t = e.touches[0]; if(!t) return;
        var rect = canvas.getBoundingClientRect();
        isHovering = isInsideTextArea(t.clientX - rect.left, t.clientY - rect.top);
      }
      function handleTouchEnd(){ isHovering = false; }

      canvas.addEventListener('mousemove', handleMouseMove);
      canvas.addEventListener('mouseleave', handleMouseLeave);
      canvas.addEventListener('touchmove', handleTouchMove, {passive:true});
      canvas.addEventListener('touchend', handleTouchEnd);

      document.addEventListener('visibilitychange', function(){
        if(document.visibilityState !== 'visible' && raf){ cancelAnimationFrame(raf); raf = null; }
        else if(document.visibilityState === 'visible' && !raf && !reduceMotionLocal){ raf = requestAnimationFrame(loop); }
      });
    };

    if(document.fonts && document.fonts.load){
      document.fonts.load(fontWeight + ' ' + fontSize + 'px ' + refFontFamily).then(init).catch(init);
    } else {
      init();
    }
  }

  canvases.forEach(function(c){ makeFuzzyLine(c, c.getAttribute('data-fuzzy-line')); });
})();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norlan-option-wheel"]) return;
  try {
    
(function(){
var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var root = document.getElementById('nrOptionWheel');
var imageEl = document.getElementById('nrWheelImage');
var detailsEl = document.getElementById('nrWheelDetails');
if(!root || !imageEl || !detailsEl) return;

var wheelDataEl = document.getElementById('nrWheelData');
var wheelData = wheelDataEl ? JSON.parse(wheelDataEl.textContent) : {};

var DATA = [
  {
    key: 'strata', name: 'STRATA BRAID',
    image: wheelData.strataImage,
    specLines: ['15 LB / 20 LB / 40 LB', '150 FT'],
    colors: ['Tiffany Blue', 'Rainbow — changes color every 10 meters'],
    traits: ['High strength', 'Low stretch', 'High sensitivity', 'Smooth long-distance casting'],
    ctaLabel: 'VIEW THIS LINE',
    ctaHref: wheelData.strataUrl
  },
  {
    key: 'prime', name: 'PRIME MONOFILAMENT',
    image: wheelData.primeImage,
    specLines: ['12 LB — 300 FT', '20 LB — 150 FT', '40 LB — 150 FT'],
    colors: ['Clear', 'Speckled Green'],
    traits: ['Soft and manageable', 'Controlled stretch', 'Shock absorption', 'Freshwater and saltwater use'],
    ctaLabel: 'VIEW THIS LINE',
    ctaHref: wheelData.primeUrl
  },
  {
    key: 'story', name: 'OUR STORY',
    image: wheelData.logoImage,
    blurb: 'Built by anglers who would rather be on the water than off it. Every spool sold funds real conservation work on the rivers we fish.',
    ctaLabel: 'READ OUR STORY',
    ctaHref: '#nr-story-section'
  },
  {
    key: 'store', name: 'FULL CATALOG',
    image: wheelData.logoImage,
    blurb: 'Every spool, every strength, in one place.',
    ctaLabel: 'BROWSE THE STORE',
    ctaHref: '/collections/all'
  }
];

function renderPanel(d){
  var html = '<h3 class="nr-wheel__name">' + d.name + '</h3>';
  if(d.specLines){
    html += '<ul class="nr-wheel__specs">' + d.specLines.map(function(s){ return '<li>' + s + '</li>'; }).join('') + '</ul>';
    html += '<div class="nr-wheel__group-label">Colors</div>';
    html += '<ul class="nr-wheel__colors">' + d.colors.map(function(c){ return '<li>' + c + '</li>'; }).join('') + '</ul>';
    html += '<ul class="nr-wheel__traits">' + d.traits.map(function(t){ return '<li>' + t + '</li>'; }).join('') + '</ul>';
  } else {
    html += '<p class="nr-wheel__blurb">' + d.blurb + '</p>';
  }
  html += '<a class="nr-wheel__cta" href="' + d.ctaHref + '">' + d.ctaLabel + '</a>';
  return html;
}

function updatePanel(index){
  var d = DATA[index];
  if(!d) return;
  var swap = function(){
    imageEl.src = d.image;
    imageEl.alt = d.name;
    detailsEl.innerHTML = renderPanel(d);
    requestAnimationFrame(function(){
      imageEl.classList.add('nr-wheel-in');
      detailsEl.classList.add('nr-wheel-in');
    });
  };
  if(reduceMotion){
    swap();
    return;
  }
  imageEl.classList.remove('nr-wheel-in');
  detailsEl.classList.remove('nr-wheel-in');
  setTimeout(swap, 180);
}

function createOptionWheel(root, opts){
  var items = opts.items;
  var defaultSelected = opts.defaultSelected || 0;
  var side = opts.side || 'left';
  var spacing = opts.spacing != null ? opts.spacing : 1.5;
  var curve = opts.curve != null ? opts.curve : 1;
  var tilt = opts.tilt != null ? opts.tilt : 10;
  var blur = opts.blur != null ? opts.blur : 2;
  var fade = opts.fade != null ? opts.fade : 0.3;
  var minOpacity = opts.minOpacity != null ? opts.minOpacity : 0.12;
  var smoothing = opts.smoothing != null ? opts.smoothing : 220;
  var loop = !!opts.loop;
  var draggable = opts.draggable !== false;
  var onChange = opts.onChange || function(){};

  root.classList.toggle('ow-right', side === 'right');
  root.setAttribute('role', 'listbox');
  root.setAttribute('aria-label', 'Product selector');
  root.tabIndex = 0;

  var itemEls = items.map(function(label, i){
    var el = document.createElement('div');
    el.className = 'ow-item';
    el.setAttribute('role', 'option');
    el.setAttribute('aria-selected', i === defaultSelected ? 'true' : 'false');
    el.textContent = label;
    root.appendChild(el);
    return el;
  });

  var rowH = 40;
  function measureRowH(){
    var probe = itemEls[0];
    if(!probe) return rowH;
    var fs = parseFloat(getComputedStyle(probe).fontSize) || 24;
    return Math.max(fs * spacing, 1);
  }
  rowH = measureRowH();

  var pos = defaultSelected, target = defaultSelected;
  var raf = null, last = 0;
  var selectedIndex = defaultSelected;
  var wheelTimer = null;
  var drag = null, dragMoved = false;

  function layout(next){
    var n = items.length;
    var mirror = side === 'right' ? -1 : 1;
    var tiltRad = tilt * Math.PI / 180;
    var R = tiltRad > 0.0005 ? rowH / tiltRad : 0;
    for(var i = 0; i < n; i++){
      var el = itemEls[i];
      var d = i - next;
      if(loop && n > 1){ d = ((d % n) + n) % n; if(d > n/2) d -= n; }
      var dist = Math.abs(d);
      var x = 0, y = d * rowH, rot = 0;
      if(R > 0){
        var ang = Math.max(-Math.PI/2, Math.min(Math.PI/2, d * tiltRad));
        y = R * Math.sin(ang);
        x = -mirror * R * (1 - Math.cos(ang)) * curve;
        rot = mirror * ang * 180 / Math.PI;
      }
      el.style.transform = 'translate(' + x.toFixed(2) + 'px, calc(' + y.toFixed(2) + 'px - 50%)) rotate(' + rot.toFixed(3) + 'deg)';
      el.style.opacity = String(Math.max(minOpacity, 1 - dist * fade));
      el.style.filter = blur > 0 ? 'blur(' + (dist * blur).toFixed(2) + 'px)' : 'none';
      el.style.setProperty('--ow-p', String(Math.max(0, 1 - Math.min(dist, 1))));
    }
  }

  function runFrame(now){
    var dt = Math.min((now - last) / 1000, 0.05);
    last = now;
    var tau = Math.max(smoothing, 1) / 1000;
    var k = 1 - Math.exp(-dt / tau);
    var next = pos + (target - pos) * k;
    var settled = Math.abs(target - next) < 0.001;
    if(settled) next = target;
    pos = next;
    layout(next);
    raf = settled ? null : requestAnimationFrame(runFrame);
  }
  function startLoop(){
    if(raf != null) return;
    last = performance.now();
    raf = requestAnimationFrame(runFrame);
  }

  function applyTarget(value, snap){
    var v = value;
    if(!loop) v = Math.min(Math.max(v, 0), Math.max(items.length - 1, 0));
    if(snap) v = Math.round(v);
    target = v;
    var idx = ((Math.round(v) % items.length) + items.length) % items.length;
    if(idx !== selectedIndex){
      if(itemEls[selectedIndex]) itemEls[selectedIndex].setAttribute('aria-selected', 'false');
      if(itemEls[idx]) itemEls[idx].setAttribute('aria-selected', 'true');
      selectedIndex = idx;
      onChange(idx, items[idx]);
    }
    if(reduceMotion){ pos = target; layout(pos); }
    else { startLoop(); }
  }

  root.addEventListener('wheel', function(e){
    e.preventDefault();
    var delta = e.deltaMode === 1 ? e.deltaY * 24 : e.deltaY;
    var step = Math.max(-1, Math.min(1, delta / rowH));
    applyTarget(target + step, false);
    if(wheelTimer) clearTimeout(wheelTimer);
    wheelTimer = setTimeout(function(){ applyTarget(target, true); }, 140);
  }, {passive: false});

  root.addEventListener('pointerdown', function(e){
    if(!draggable) return;
    drag = {y: e.clientY, start: target, id: e.pointerId};
    dragMoved = false;
    root.classList.add('ow-dragging');
  });
  root.addEventListener('pointermove', function(e){
    if(!drag) return;
    var dy = e.clientY - drag.y;
    if(!dragMoved && Math.abs(dy) > 4){
      dragMoved = true;
      try{ root.setPointerCapture(drag.id); } catch(err){}
    }
    if(dragMoved) applyTarget(drag.start - dy / rowH, false);
  });
  function endDrag(){
    if(!drag) return;
    drag = null;
    root.classList.remove('ow-dragging');
    if(dragMoved) applyTarget(target, true);
  }
  root.addEventListener('pointerup', endDrag);
  root.addEventListener('pointercancel', endDrag);

  itemEls.forEach(function(el, index){
    el.addEventListener('click', function(){
      if(dragMoved) return;
      var cur = target;
      var d = index - (((cur % items.length) + items.length) % items.length);
      if(loop && items.length > 1){
        if(d > items.length/2) d -= items.length;
        else if(d < -items.length/2) d += items.length;
      }
      applyTarget(cur + d, true);
    });
  });

  root.addEventListener('keydown', function(e){
    var delta = null;
    if(e.key === 'ArrowUp' || e.key === 'ArrowLeft') delta = -1;
    else if(e.key === 'ArrowDown' || e.key === 'ArrowRight') delta = 1;
    if(delta == null) return;
    e.preventDefault();
    applyTarget(Math.round(target) + delta, true);
  });

  var resizeTimer;
  window.addEventListener('resize', function(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function(){
      rowH = measureRowH();
      layout(pos);
    }, 150);
  });

  applyTarget(defaultSelected, false);
}

createOptionWheel(root, {
  items: ['STRATA', 'PRIME', 'OUR STORY', 'STORE'],
  defaultSelected: 0,
  side: 'left',
  spacing: 1.5,
  curve: 1,
  tilt: 10,
  blur: 2,
  fade: 0.3,
  minOpacity: 0.12,
  smoothing: 220,
  loop: false,
  draggable: true,
  onChange: function(index){ updatePanel(index); }
});
updatePanel(0);
})();

  } catch(e) { console.error(e); }
})();
})();
